<template>
    <div class="form section-e dealer-form">
        <div class="section-subhead">
            <i v-if="locked" class="fa fa-lock" style="padding: 0 0.25em 0 0; cursor: pointer;" @click="showLockedReason()"></i>
			Section E - Transferor / Seller (2023)
        </div>
        <div class="section-e-detail">
            <div class="section-e-section two-columns" style="margin: 0 0 1em 0;">
				<div>
					<label>For Use by Licensee</label>
					<textarea v-model="form.form_data.section_e.seller_notes" />
					<div class="button neutral inline" @click="saveNotes()">Save</div>
				</div>
				<div style="position: relative;">
					<label>Trade Name, Address, FFL Number</label>
					<textarea v-model="form.form_data.section_e.seller_name_address_ffl"/>
					<div v-if="isLocked" style="position: absolute; top: 0em; left: 0; width: 100%; height: 100%; cursor: not-allowed;" @click="showLockedReason()"></div>
				</div>
			</div>
			<div style="position: relative">
				<p><strong>I certify that: (1) I have read and understand the Notices, Instructions, and Definitions on this ATF Form 4473; (2) the information recorded in Sections A, C and E is true, correct, and complete; and (3) this entire transaction record has been completed at the licensed business premises (“licensed premises” includes business temporarily conducted from a qualifying gun show or event in the same State in which the licensed premises is located) unless this transaction has met the requirements of 18U.S.C.§922(c). Unless this transaction has been denied or canceled by NICS or State agency, I further certify on the basis of — (1) the transferee’s/buyer’s responses in Section B (and Section D, if applicable); (2) the verification of the identification recorded in question 26 (and the re-verification at the time of transfer, if Section D was completed); and (3) State or local law applicable to the firearms business — it is my belief that it is not unlawful for me to sell, deliver, transport, or otherwise dispose of the firearm(s) listed on this form to the person identified in Section B. If this transaction required a NICS check, I further certify that this firearm(s) transfer is within 30 days from the date of NICS contact.</strong></p>
				<div class="section-e-section two-columns">
					<div>
						<label>Transferor's / Seller's Name</label>
						<input type="text" v-model="form.form_data.section_e.seller_name"/>
					</div>
					<div class="two-columns align-center" style="grid-gap: 0; grid-template-columns: 16em 1fr;">
						<div style="position: relative;">
							<label>Date Transferred</label>
							<input type="date" v-model="form.form_data.section_e.transfer_date" :min="minimumTransferDate" style="width: 13em;" :disabled="isLocked || form.form_data.section_e.not_transferred == true" @change="setTransferDateWarning()" />
							<div v-if="minimumTransfserDateReason" style="position: absolute; top: 6.5em; left: 0; border: 1px solid #ccc; padding: 0.25em;">
								<span class="note">{{ minimumTransfserDateReason }}</span>
							</div>
						</div>
						<div>
							<checkbox v-if="!isLocked" v-model="acceptTodaySectionE" label="Check here to accept today's date" />
						</div>
						<div style="clear: left;">
							<checkbox v-model="form.form_data.section_e.not_transferred" label="Not Transferred" />
						</div>
						<div>
							<div v-if="!isLocked && transferDateBanner" class="note" :style="{ color: 'red', fontWeight: 'bold' }">More than 30 days have passed since the initial NICS transmission date. If this transfer requires a NICS check, it should not be completed.</div>
							<div v-if="transferDateWarning" class="note" :style="isNICSCheckOutOfDate ? { color: 'red', fontWeight: 'bold' }: {}">{{ transferDateWarning }}</div>
						</div>
					</div>
				</div>
				<div v-if="isLocked" style="position: absolute; top: 0em; left: 0; width: 100%; height: 100%; cursor: not-allowed;" @click="showLockedReason()"></div>
			</div>
			<div v-if="form.form_data.section_e.seller_signature" style="margin: 1em 0 0 1em;">
				<img class="signature" :src="form.form_data.section_e.seller_signature">
				<div v-if="!isLocked" style="margin: 1em 0 0 0;">
					<div class="button neutral inline" @click="form.form_data.section_e.seller_signature = ''">Clear Signature</div>
				</div>
			</div>
			<div v-else style="margin: 1em 0 0 0; position: relative;">
				<signature-inputs v-model="form.form_data.section_e.seller_signature" :enableSignOnScreen="enableSignOnScreen" :key="'sos_' + enableSignOnScreen" />
				<div v-if="isLocked" style="position: absolute; top: 0em; left: 0; width: 100%; height: 100%; cursor: not-allowed;" @click="showLockedReason()"></div>
			</div>
		</div>

		<div v-if="confirmAlert" class="modal">
		<div class="inner">
			<h2>Alert</h2>
			<div class="content">
				<p>{{ form.alert }}</p>
				<p>Are you sure you want to proceed with Section E?</p>
			</div>
			<div class="controls">
				<div class="button neutral spaced" @click="confirmAlert = false">Yes</div>
				<div class="button neutral spaced" @click="lockWithAlert()">No</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>
</template>

<script>
import CDSDateInput from '@/components/CDSDateInput.vue'
import Checkbox from '@/components/Checkbox.vue'
import SignatureInputs from '@/components/SignatureInputs.vue'
export default {
	name: 'form4473-section-e',
	props: ['form', 'locked', 'enableSignOnScreen', 'correcting'],
	components: {
		'date-input': CDSDateInput,
		'checkbox': Checkbox,
		'signature-inputs': SignatureInputs
	},
	data() {
		return {
			loading: false,
			message: '',
			saving: false,
			messageTimeout: 0,
			today: '',
			todayFormatted: '',
			minimumTransferDate: '',
			minimumTransfserDateReason: '',
			acceptTodaySectionE: false,
			transferDateWarning: '',
			confirmAlert: false,
			lockedByAlert: false,
			isNICSCheckOutOfDate: false
		}
	},
	created() {
		console.log(this.locked)
		let theDate = this.$moment()
		this.today = theDate.format('YYYY-MM-DD')
		this.todayFormatted = theDate.format('MM/DD/YYYY')
		this.calculateMinimumTransferDate()
		if (this.form.alert) {
			this.confirmAlert = true
		} else {
			// alert the user if section e and if today is later than section b signed date and no section d
			// NOTE: uncomment lockSection code (and showLockedReason code in 4473SectionE.vue) if we decide to actually lock section e
			if (!this.form.form_data.section_e.seller_signature && this.form.form_data.section_b.signed_date < this.todayFormatted && !this.form.form_data.section_d.buyer_recertification_date) {
				this.messageStatus = 'alert'
				this.message = 'Section B signed date ' + this.form.form_data.section_b.signed_date + ' has passed.<br>Your customer should complete Section D before transfer.<br>Or you can complete Section E and mark as Not Transferred.'
			}
		}
	},
	computed: {
		isLocked() {
			return this.locked || this.lockedByAlert
		},
		transferDateBanner() {
			return this.$moment(new Date()).diff(this.$moment(this.form.form_data.section_c.nics_initial_response_date), 'days') > 30
		}
	},
	watch: {
		'acceptTodaySectionE' (newVal) {
			if (newVal) {
				this.form.form_data.section_e.transfer_date = this.today
				this.setTransferDateWarning()
			} else {
				this.form.form_data.section_e.transfer_date = ''
				this.setTransferDateWarning()
			}
		},
		'form.form_data.section_e.not_transferred' (newVal) {
			if (newVal) {
				this.form.form_data.section_e.transfer_date = ''
			}
		}
	},
    methods: {
		setTransferDateWarning() {
			this.transferDateWarning = ''
			this.isNICSCheckOutOfDate = (this.$moment(this.form.form_data.section_e.transfer_date).diff(this.$moment(this.form.form_data.section_c.nics_initial_response_date), 'days') > 30)
			if (this.form.form_data.section_e.transfer_date && this.form.form_data.section_d.buyer_recertification_date) {
				if (this.$moment(this.form.form_data.section_e.transfer_date).format('YYYY-MM-DD') != this.$moment(this.form.form_data.section_d.buyer_recertification_date).format('YYYY-MM-DD')) {
					this.transferDateWarning = "This transfer date does not match the Section D buyer certification date (" + this.form.form_data.section_d.buyer_recertification_date + "). If you're sure this is correct, you can ignore this warning."
				}
			} else if (this.form.form_data.section_e.transfer_date && this.form.form_data.section_b.signed_date) {
				if (this.$moment(this.form.form_data.section_e.transfer_date).format('YYYY-MM-DD') != this.$moment(this.form.form_data.section_b.signed_date).format('YYYY-MM-DD')) {
					this.transferDateWarning = "This transfer date does not match the Section B buyer certification date (" + this.form.form_data.section_b.signed_date + "). If you're sure this is correct, you can ignore this warning."
				}
			}
		},
        saveNotes() {
			if (this.saving || !this.form.form_data.section_e.seller_notes) { return }
			this.saving = true
			this.message = 'Saving notes'
			if (this.form.form_data.section_e.seller_notes) {
                this.apiCall({ destination: 'save_4473_notes', data: { ffl_log_book_form_id: this.form.ffl_log_book_form_id, notes: this.form.form_data.section_e.seller_notes } }).then(obj => {
                    this.saving = false
                    this.message = obj.message
					this.messageTimeout = 3000
                })
            }
        },
		calculateMinimumTransferDate() {
			this.minimumTransferDate = this.today
			this.minimumTransfserDateReason = ''
			if (this.form.form_data.section_b.signed_date && this.form.form_data.section_b.signed_date > this.minimumTransferDate) {
				this.minimumTransferDate = this.form.form_data.section_b.signed_date
				this.minimumTransfserDateReason = 'Date Transferred must be on or after Section B certification date: ' + this.$moment(this.form.form_data.section_b.signed_date).format('MM/DD/Y')
			}
			if (this.form.form_data.section_c.nics_firearm_may_be_transferred && this.form.form_data.section_c.nics_firearm_may_be_transferred > this.minimumTransferDate) {
				this.minimumTransferDate = this.form.form_data.section_c.nics_firearm_may_be_transferred
				this.minimumTransfserDateReason = 'Date Transferred must be on or after Section C firearm(s) may be transferred date: ' + this.$moment(this.form.form_data.section_c.nics_firearm_may_be_transferred).format('MM/DD/Y')
			}
			if (this.form.form_data.section_c.nics_later_response_proceed && this.form.form_data.section_c.nics_later_response_proceed_date && this.form.form_data.section_c.nics_later_response_proceed_date < this.minimumTransferDate) {
				this.minimumTransferDate = this.form.form_data.section_c.nics_later_response_proceed_date
				this.minimumTransfserDateReason = 'Date Transferred must be on or after Section C prior to transfer later proceed date: ' + this.$moment(this.form.form_data.section_c.nics_later_response_proceed_date).format('MM/DD/Y')
			}
			if (this.form.form_data.section_c.nics_additional_delay_transfer_date && this.form.form_data.section_c.nics_additional_delay_transfer_date > this.minimumTransferDate) {
				this.minimumTransferDate = this.form.form_data.section_c.nics_additional_delay_transfer_date
				this.minimumTransfserDateReason = 'Date Transferred must be on or after Section C additional delay of transferee under 21 date: ' + this.$moment(this.form.form_data.section_c.nics_additional_delay_transfer_date).format('MM/DD/Y')
			}
			if (this.form.form_data.section_d.buyer_recertification_date && this.form.form_data.section_d.buyer_recertification_date > this.minimumTransferDate) {
				this.minimumTransferDate = this.form.form_data.section_d.buyer_recertification_date
				this.minimumTransfserDateReason = 'Date Transferred must be on or after Section D buyer recertification date: ' + this.$moment(this.form.form_data.section_d.buyer_recertification_date).format('MM/DD/Y')
			}
		},
		showLockedReason() {
			if (!this.isLocked) { return }
			if (this.form.alert) {
				this.message = this.form.alert
			} else {
				this.message = 'Section E is locked because<br>'
				if (this.form.internal_use_only == 2) {
					this.message += 'this form is awaiting correction by the customer.'
				} else if (this.form.moved_to_ffl_log_book_form_id) {
					this.message += 'it is a previous version of a corrected form.'
				} else if (this.form.form_data.section_e.seller_signature) {
					this.message += 'it has been signed.'
				} else if (!this.form.form_data.section_c) {
					this.message += "Section C is required."
				} else if (Object.values(this.form.form_data.section_c.customer_trans_purpose).every(x => x === null || x === '')) {
					this.message += "Section C Category of Firearm(s) to be Tranferred is required."
				} else if (!this.form.form_data.section_c.buyer_identification_issuing_authority_and_type) {
					this.message += "Section C Identification, Issuing Authority is required."
				} else if (!this.form.form_data.section_c.buyer_identification_type_code) {
					this.message += "Section C Identification, Type of Identfication is required."
				} else if (!this.form.form_data.section_c.buyer_identification_number) {
					this.message += "Section C Identification, Number on Identification is required."
				} else if (!this.form.form_data.section_c.nics_buyer_background_check && !this.form.form_data.section_c.nics_buyer_exempt && !this.form.form_data.section_c.nics_initial_response_date) {
					this.message += "Section C Date the transferee’s/buyer’s identifying information<br>in Section B was transmitted to NICS or the appropriate State agency<br>is required."
				} else if (!this.form.form_data.section_c.nics_buyer_background_check && !this.form.form_data.section_c.nics_buyer_exempt && !this.form.nics_number && !this.form.form_data.section_c.no_nics_number_provided) {
					this.message += "Section C The NICS or State transaction number is required."
				} else if (!this.form.form_data.section_c.nics_buyer_background_check && !this.form.form_data.section_c.nics_buyer_exempt && !this.form.form_data.section_c.nics_initial_response) {
					this.message += "Section C The Response Initially Provided by NICS<br>or the Appropriate State Agency is required."
				//} else if (!this.form.form_data.section_e.seller_signature && this.form.form_data.section_b.signed_date < this.todayFormatted && !this.form.form_data.section_d.buyer_recertification_date) {
				//	this.message += 'Section B signed date ' + this.form.form_data.section_b.signed_date + ' has passed<br>and there is no signed Section D.'
				} else {
					this.message += 'previous required sections have not been completed.'
				}
			}
			this.messageStatus = 'alert'
		},
		validateSection() {
			let data = this.form.form_data.section_e
			let errorMessage = ''
			if (!data.seller_name_address_ffl) {
				errorMessage = 'Trade Name, Address, FFL Number is required.'
			}
			if (!errorMessage && !data.seller_name) {
				errorMessage = "Transferor's / Seller's Name is required."
			}
			if (!errorMessage && !data.seller_signature) {
				errorMessage = 'Signature is required.'
			}
			if (!errorMessage && !data.transfer_date && !data.not_transferred) {
				errorMessage = 'Date Transferred is required.'
			}
			return errorMessage
		},
		lockWithAlert() {
			this.lockedByAlert = true
			this.confirmAlert = false
		}
	}
}
</script>
